module.exports = __webpack_public_path__ + "media/images/logos/fl-logo-small-031ecac99b4230f365096fc6994418c1.svg";